export default "__VITE_ASSET__DRUWVO_I__"